<template>
  <div v-show="false" class="top-split">
    <el-row :gutter="20">
      <el-col :span="1"></el-col>
      <el-col :span="3">
        <el-button type="primary" @click="applyDialog = true">申请盆友</el-button>
      </el-col>
      <el-col :span="19">
        <div class="kb-div"></div>
      </el-col>
    </el-row>
  </div>

  <div v-show="false" class="my-top">
    <el-row :gutter="20">
      <el-col :span="1"></el-col>
      <el-col :span="1">
        <div class="my-top-sp"></div>
      </el-col>
      <el-col :span="22">
        <div class="my-top-div">小破站名称:小七的个人页</div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="1"></el-col>
      <el-col :span="1">
        <div class="my-top-sp"></div>
      </el-col>
      <el-col :span="22">
        <div class="my-top-div">小破站地址:https://xqcc.site</div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="1"></el-col>
      <el-col :span="1">
        <div class="my-top-sp"></div>
      </el-col>
      <el-col :span="22">
        <div class="my-top-div">小破站图标:https://xqcc.site/logo.ico</div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="1"></el-col>
      <el-col :span="1">
        <div class="my-top-sp"></div>
      </el-col>
      <el-col :span="22">
        <div class="my-top-div">小破站简介:一个腿菜的长跑爱好者</div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="1"></el-col>
      <el-col :span="1">
        <div class="my-top-sp"></div>
      </el-col>
      <el-col :span="22">
        <div class="my-top-div">PS:简单收录几个大神的博客撑个门面,至于我的嘛,需要互换的可以发邮件~</div>
      </el-col>
    </el-row>
  </div>

  <!--链接体-->
  <shipLink
      v-for="(item, index) in shipList"
      :key="item"
      :item="item"
      :index="index"
      class="animate__animated animate__fadeInDown"
  ></shipLink>
  <!--申请框-->
  <el-dialog width="50%"
             style="background-image: linear-gradient(to top, #f3e7e9 0%, #e3eeff 99%, #e3eeff 100%);
                    font-family: 方正舒体;
                    border-radius: 15px"
             :before-close="closeNewShip"
             v-model="applyDialog" title="申请盆友圈">
    <div>
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="ship-input-name">名称</div>
        </el-col>
        <el-col :span="16">
          <el-input v-model="shipName" placeholder="小七的个人页" autocomplete="off"/>
        </el-col>
      </el-row>
    </div>

    <div class="ship-input-row">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="ship-input-name">简介</div>
        </el-col>
        <el-col :span="16">
          <el-input v-model="shipInfo" placeholder="一个腿菜的长跑爱好者~" autocomplete="off"/>
        </el-col>
      </el-row>
    </div>

    <el-row class="ship-input-row" :gutter="20">
      <el-col :span="6">
        <div class="ship-input-name">链接</div>
      </el-col>
      <el-col :span="16">
        <el-input v-model="shipUrl" placeholder="https://xqcc.site" autocomplete="off"/>
      </el-col>
    </el-row>

    <el-row class="ship-input-row" :gutter="20">
      <el-col :span="6">
        <div class="ship-input-name">图标</div>
      </el-col>
      <el-col :span="16">
        <el-input v-model="shipIcon" placeholder="https://xqcc.site/logo.ico" autocomplete="off"/>
      </el-col>
    </el-row>

    <el-row class="ship-input-row" :gutter="20">
      <el-col :span="6">
        <div class="ship-input-name">邮箱</div>
      </el-col>
      <el-col :span="16">
        <el-input v-model="shipMail" placeholder="填写您的联系方式，不做为隐私收藏~" autocomplete="off"/>
      </el-col>
    </el-row>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeNewShip()">关闭</el-button>
        <el-button type="primary" @click="saveNewShip()">
          提交
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
//友情链接
import shipLink from "./shipLink";
//封装好的axios
import {getRequest, postRequest} from '@/utils/service'
import {baseUrl} from '@/utils/request'
import {ElMessage, ElNotification} from "element-plus";
//正则
import {validateURL, validateMail, validateSpace} from '@/utils/rule'

export default {
  name: "shipList",
  components: {shipLink},
  data() {
    return {
      baseUrl: '',
      //子组建数组
      shipList: [],
      //弹出框
      applyDialog: false,
      //名称
      shipName: '',
      //简介
      shipInfo: '',
      //链接
      shipUrl: '',
      //图标
      shipIcon: '',
      //邮箱
      shipMail: ''
    }
  },
  props: {},
  created() {
    this.baseUrl = baseUrl();
    //加载朋友列表
    this.loadShipList();
  },
  methods: {
    loadShipList() {
      //判断页码
      let page = 1;
      let total = this.shipList.length;
      if (total > 10) {
        page = total / 10;
      }

      //查询后台数据
      getRequest(this.baseUrl + '/ship/getShip?page=' + page + '&limit=10')
          .then((res) => {
            let data = res.data.data;

            //标识位
            let num = 0;
            //标识对象
            let obj = {};
            //将数组转两个的对象  神奇操作
            for (let i = 0; i < data.length; i++) {

              //单数放第一个 双数放第二个
              if (i % 2 === 0) {
                obj.item1 = data[i];
                num++;
              } else {
                obj.item2 = data[i];
                num++;
              }

              //满两个存一次 或者最后一个存一次
              if (num === 2 || i === data.length - 1) {
                this.shipList.push(obj);
                obj = {};
                num = 0
              }
            }
          })
          .catch(function (error) {
            ElMessage.error(error)
          })
    },
    //保存
    saveNewShip() {
      //名称必填
      if (!validateSpace(this.shipName)) {
        ElMessage.error('名称必填哦..')
        return;
      }

      //网址正则校验
      if (!validateURL(this.shipUrl)) {
        ElMessage.error('URL校验不通过,请输入正确的网址.')
        return;
      }

      //图标网址正则校验
      if (!validateURL(this.shipIcon)) {
        ElMessage.error('图标URL校验不通过,请输入正确的图标网址.')
        return;
      }

      //邮箱正则校验
      if (!validateMail(this.shipMail)) {
        ElMessage.error('邮箱校验不通过,请输入正确的邮箱地址.')
        return;
      }

      //新增
      let obj = {
        shipName: this.shipName,
        shipInfo: this.shipInfo,
        shipUrl: this.shipUrl,
        shipIcon: this.shipIcon,
        shipMail: this.shipMail
      }

      //保存
      postRequest(this.baseUrl + '/ship/saveShip', obj).then((res) => {
        let num = res.data.data;
        //状态码确认
        if (num > 0) {
          //清空输入框 关闭弹框
          this.applyDialog = false;
          this.shipName = ''
          this.shipInfo = ''
          this.shipUrl = ''
          this.shipIcon = ''
          this.shipMail = ''

          ElNotification({
            title: '申请成功',
            message: '已经提交,等待博主审核中...',
            type: 'success'
          })
        } else if (num === -1) {
          ElNotification({
            title: '申请异常',
            message: '已经提交申请，请勿重复提交哦...',
            type: 'error'
          })
        } else {
          ElNotification({
            title: '申请异常',
            message: '不存在的状态码...',
            type: 'error'
          })
        }
      })
          .catch(function (error) {
            ElMessage.error(error)
          })
    },
    //关闭窗口
    closeNewShip() {
      //清空输入框 关闭弹框
      this.applyDialog = false;
      this.shipName = ''
      this.shipInfo = ''
      this.shipUrl = ''
      this.shipIcon = ''
      this.shipMail = ''
    }
  }
}
</script>

<style scoped>
.kb-div {
  width: 100%;
  height: 5px;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.15) 0%, rgba(0, 0, 0, 0.15) 100%), radial-gradient(at top center, rgba(255, 255, 255, 0.40) 0%, rgba(0, 0, 0, 0.40) 120%) #989898;
  margin-top: 15px;
}

.top-split {
  margin-top: 15px;
}

.ship-input-name {
  text-align: center;
  font-size: 17px;
  height: 20px;
  line-height: 20px;
}

.ship-input-row {
  margin-top: 10px;
}

.my-top {
  margin-top: 15px;
  margin-left: 15px;
  font-family: 方正舒体;
  border-radius: 15px;
  /*background-image: linear-gradient(to top, #cfd9df 0%, #e2ebf0 100%);*/
}

.my-top-div {
  height: 20px;
  line-height: 20px;
  font-size: 18px;
  margin-bottom: 10px;
}

.my-top-sp {
  width: 10px;
  height: 18px;
  margin-top: 1px;
  background-color: #988694;
  border-radius: 15px;
}

</style>